
export const statusSelected = [
  { id: 'ACTIVE', name: "Ativo" },
  { id: 'INACTIVE', name: "Inativo" },
];